import { render } from "./driver-card.vue?vue&type=template&id=251cf637&scoped=true"
import script from "./driver-card.vue?vue&type=script&lang=js"
export * from "./driver-card.vue?vue&type=script&lang=js"

import "./driver-card.vue?vue&type=style&index=0&id=251cf637&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251cf637"]])

export default __exports__